export default __webpack_public_path__ + "static/media/IMG_5547.557750a7.jpg";